'use client';

import MenuIcon from '@web-libs/ui/svgs/icons/MenuIcon';
import { withColor } from '@web-libs/ui/svgs/fill/with-color';
import { withClick } from '@web-libs/ui/svgs/clickable/with-click';
import { CSSProperties, useState } from 'react';
import { getCssVar } from '@web-libs/features/colors/application/colors';
import CloseIcon from '@web-libs/ui/svgs/icons/CloseIcon';
import { PublicMobileMenu } from '@web-libs/features/navigation/public-mobile-menu';
import { PrivateMobileMenu } from '@web-libs/features/navigation/private-mobile-menu';

export const MobileMenu = ({ isPublicArea }: { isPublicArea: boolean }) => {

  const [overlayOpen, setOverlayOpen] = useState(false);

  const overlayStyles: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100%', // Changed from 100vh to 100% for better iOS compatibility
    backgroundColor: getCssVar('light'),
    zIndex: 1000,
    paddingRight: 20,
    paddingLeft: 20,
    paddingTop: 48,
    paddingBottom: 48,
    overflowY: 'auto', // Changed from scroll to auto for better behavior
    WebkitOverflowScrolling: 'touch', // Added for smooth scrolling on iOS
    transition: 'transform 0.3s ease-in-out',
    transform: overlayOpen ? 'translateX(0)' : 'translateX(100%)' // Slide effect
  };

  const MenuButton = withClick(withColor(MenuIcon));
  const CloseButton = withClick(CloseIcon);

  const close = () => {
    setOverlayOpen(false);
  };

  return (
    <div>
      <MenuButton onClick={() => {
        setOverlayOpen(true);
      }} />

      <div style={overlayStyles}>
        <div style={{ display: 'flex', justifyContent: 'end', marginBottom: 32 }}>
          <CloseButton onClick={close} height={24} width={24} />
        </div>
        {isPublicArea &&
          <PublicMobileMenu close={close} />
        }
        {!isPublicArea &&
          <PrivateMobileMenu close={close} />
        }
      </div>

    </div>
  );
};
